import { theme } from '@theme';
import styled from 'styled-components';

export const NotificationContainerWrapper = styled.div`
  > a {
    color: ${theme.palette.white};
    line-height: 34px;
    cursor: pointer;
    height: 60px;
    padding: 15px;
    text-decoration: none;
    transition: border-bottom-width 0.15s ease-in;
    border-bottom-width: 0px;
    position: relative;
    user-select: none;
    display: block;
  }
  &:hover {
    background-color: ${theme.palette.borderPurple};
  }
`;

export const NotificationBar = styled.div<{ isMobileDevice: boolean }>`
  background-color: ${theme.palette.white};
  position: absolute;
  top: 60px;
  right: 0;
  z-index: 10000;
  width: ${(props) => (props.isMobileDevice ? '100vw' : '548px')};
  height: ${(props) => (props.isMobileDevice ? '100vh' : '')};
  border: 1px solid ${theme.palette.toolTipBackground};
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  &:hover {
    cursor: default;
  }
`;

export const BadgeItem = styled.a<{ isMobileDevice: boolean }>`
  color: ${theme.palette.white};
  line-height: 34px;
  cursor: pointer;
  height: 60px;
  padding: 15px;
  text-decoration: none;
  transition: border-bottom-width 0.15s ease-in;
  border-bottom-width: 0px;
  position: relative;
  display: block;

  &:hover {
    color: ${theme.palette.white};
    text-decoration: none;
    background-color: ${theme.palette.borderPurple};
  }

  @media (max-width: 992px) {
    padding-left: 14px;
    padding-right: 14px;
  }

  .am-icon-bell {
    font-size: ${(props) => (props.isMobileDevice ? '172%' : '150%')};
`;

export const NotifBadge = styled.span<{ isMobileDevice: boolean }>`
  display: block;
  position: absolute;
  background: ${theme.palette.red};
  border-radius: 2px;
  color: ${theme.palette.text.white};
  line-height: ${(props) => (props.isMobileDevice ? '15' : '11')}px;
  box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.1);
  font-size: ${(props) => (props.isMobileDevice ? '15' : '11')}px;
  font-weight: ${theme.typography.fontWeights.medium};
  padding: 1px 5px 1px 4px;
  right: 4px;
  top: 7px;
  min-width: 15px;
  text-align: center;
  border-bottom: 1px solid rgba(0, 0, 0, 0.5);
`;

export const TabNavNotifBadge = styled(NotifBadge).attrs({
  className: 'notif-badge',
})`
  opacity: 0.5;
  top: -5px;
  right: -5px;
  background-color: ${theme.palette.darkPurpleEUI};
`;

export const ExportDealsheets = styled.div`
  text-align: right;
  padding: 3px 10px 1px;
  display: inline-block;
  width: 50%;
`;

export const MobileRefreshNotifications = styled(ExportDealsheets)<{ isMobileDevice: boolean }>`
  ${(props) =>
    props.isMobileDevice
      ? `
      vertical-align: sub;
      `
      : ``}
`;

export const BottomActions = styled.div`
  padding: 3px 0 2px;
  font-size: 11px;
  text-align: center;
`;

export const VisibilityToggle = styled.div<{ isMobileDevice: boolean }>`
  text-align: left;
  padding: 3px 10px 1px;
  display: inline-block;
  width: 50%;
  ${(props) =>
    props.isMobileDevice
      ? `
    font-size: ${theme.typography.h6}px;
    line-height: 3;
  `
      : ``}
`;

export const ReadUnreadExportContainer = styled.div`
  min-height: 0;
  padding: 3px 0 2px;
  font-size: 11px;
  background-color: ${theme.palette.white};
  margin: 0 -10px;
  cursor: pointer;
  span {
    color: ${theme.palette.blue};
    .am-icon {
      position: static;
      font-size: 150%;
      vertical-align: sub;
    }
  }
  &:hover {
    span {
      color: ${theme.palette.blue};
    }
  }
`;

export const GlobalActions = styled.div`
  position: absolute;
  right: 38px;
  top: 8px;
`;

export const MarkAsRead = styled.a`
  color: ${theme.palette.skyBlue};
  font-size: 11px;

  &:hover {
    color: ${theme.palette.skyBlue};
  }
`;

export const CloseIcon = styled.span`
  i {
    position: absolute;
    top: 5px;
    right: 5px;
    color: ${theme.palette.white};
    text-shadow: none;
    opacity: 1;
    font-size: 160%;
    line-height: 1;
    float: right;
    font-weight: ${theme.typography.fontWeights.light};

    &:hover {
      color: ${theme.palette.vibrantPurpleTwo};
      text-decoration: none;
      cursor: pointer;
    }
  }
`;

export const NotificationsHead = styled.header`
  background: ${theme.palette.text.purple};
  padding: 10px 10px 0;
  border-bottom: 1px solid ${theme.palette.lightPurpleSix};
  position: relative;
`;

export const NotificationsLabel = styled.h3`
  color: ${theme.palette.text.white};
  text-transform: uppercase;
  font-size: ${theme.typography.fontSize}px;
  font-weight: ${theme.typography.fontWeights.bold};
  margin: 0;
  line-height: 1.1;
`;
export const StyledLink = styled.a`
  color: #337ab7;
  text-decoration: none;
  cursor: pointer;
`;
export const TabNav = styled.ol<{ isMobileDevice: boolean; showScroll: boolean }>`
  margin: 10px 0 0;
  padding: 0;

  .scroll-tabs-wrapper {
    position: relative;
    display: flex;
    align-items: center;
    background-color: ${theme.palette.text.purple};
    border-radius: 6px 6px 0 0;
  }

  .scroll-tabs-wrapper button {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    border: none;
    width: 38px;
    height: 38px;
    font-size: 22px;
    font-weight: bold;
    color: #454545;
    cursor: pointer;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${theme.palette.vibrantPurple};
    &::after {
      content: '';
      position: absolute;
      top: 0;
      bottom: 0;
      width: 4px;
      background-color: ${theme.palette.text.purple};
    }
  }

  .scroll-tabs-wrapper button:hover {
    background-color: #f5effe;
  }

  .scroll-container {
    overflow: hidden;
    flex: 1;
    position: relative;
    max-width: 100%;
    border-radius: 4px;
  }

  .scroll-tabs-wrapper .am-icon-angle-left {
    left: -10px;
    border-radius: 0 3px 3px 0;
    &::after {
      right: -4px;
    }
  }
  .scroll-tabs-wrapper .am-icon-angle-right {
    right: -10px;
    border-radius: 3px 0 0 3px;
    &::after {
      left: -4px;
    }
  }

  .am-icon-angle-left,
  .am-icon-angle-right {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 2;
    background: ${theme.palette.white};
    border: 1px solid ${theme.palette.gray};
    color: ${theme.palette.black};
    font-size: 18px;
    cursor: pointer;
    padding: 4px 8px;
    border-radius: 4px;
  }

  .am-icon-angle-left {
    left: 0;
  }

  .am-icon-angle-right {
    right: 0;
  }

  .scroll-wrapper {
    overflow-x: auto;
    display: flex;
    flex-grow: 1;
    padding-top: 10px;

    /* hide scroll in firefox */
    scrollbar-width: none;
    -ms-overflow-style: none;
  }
  .scroll-wrapper::-webkit-scrollbar {
    display: none; /* Chrome, Safari */
  }

  li {
    list-style: none;
    display: inline-block;
    padding: 10px 10px 6px;
    color: ${theme.palette.white};
    font-size: ${theme.typography.h5}px;
    cursor: pointer;
    position: relative;

    &:hover {
      .am-icon {
        color: ${theme.palette.white};
      }
      &:not(.active) {
        .notif-badge {
          display: block;
        }
      }
    }
    .am-icon {
      font-size: 230%;
      line-height: 0.5;
      vertical-align: text-bottom;
    }
    .am-icon-score-product {
      line-height: 0.4;
    }
    .am-icon-score-payment {
      font-size: 220%;
    }
    .am-icon-birthday {
      font-size: 180%;
    }
    .am-icon-score-warranty {
      font-size: 240%;
    }
    .am-icon-service,
    .am-icon-reassign-deal,
    .am-icon-private-incentive {
      font-size: 180%;
    }
    .am-icon-eye {
      font-size: 200%;
    }
    .am-icon-conquest {
      margin-left: -4px;
      margin-right: -4px;
      font-size: 210%;
    }
    .am-icon-campaign {
      font-size: 200%;
      margin-left: -3px;
    }
    .am-icon-visit {
      font-size: 200%;
    }
    .am-icon-showroom {
      font-size: 200%;
      margin-left: -5px;
    }

    &.active {
      box-shadow: 0 -2px 6px rgba(0, 0, 0, 0.2);
      border: 1px solid ${theme.palette.palePurpleTwo};
      border-bottom: 0;
      background-color: ${theme.palette.white};
      border-radius: 4px 4px 0 0;
      color: ${theme.palette.text.purple};
      margin-left: 0px;
      &:after {
        content: '';
        position: absolute;
        left: 0;
        right: 0;
        bottom: -2px;
        height: 3px;
        background: ${theme.palette.white};
      }
      &:hover {
        .am-icon {
          color: ${theme.palette.text.purple};
        }
      }
      .notif-badge {
        opacity: 1;
      }
    }

    .__react_component_tooltip.place-top {
      margin-top: -21px;
    }
    ${(props) => (props.isMobileDevice ? 'margin: 10px 2% 0px 2%; padding-bottom: 10px;' : '')}
  }
`;
